import React from "react";
import {
  TextInput,
  ImageInput,
  // Notification,
  minLength,
  maxLength,
  useQueryWithStore
} from "react-admin";

import Icon from '@material-ui/core/Icon';

// import { green } from "@material-ui/core/colors";
import {
  CheckboxGroupInput,
  regex,
  email,
  required,
  AutocompleteArrayInput
} from "react-admin";
// import clsx from 'clsx';
import GoogleLogin from "react-google-login";
// import { Form, Field } from "react-final-form";
// import { useAuthProvider } from "react-admin";
// import { TextField, Checkbox } from "final-form-material-ui";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
// import CircularProgress from "@material-ui/core/CircularProgress";
import { SelectInput } from "react-admin";
import { PasswordInput } from "react-admin";
// import { makeStyles } from '@material-ui/core/styles';
// import { DropDownList } from '@progress/kendo-react-dropdowns';
import {
  Paper,
  Grid
  // CssBaseline,
  // FormControlLabel
} from "@material-ui/core";
import LinkedinLogo from "./../../images/linkedin.png";
import GoogleLogo from "./../../images/google.png";
import addcircle from "./../../images/add-circle.svg";
// import Avatar from '@material-ui/core/Avatar';
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import * as yup from "yup";
import { CustomImagePreview } from "../../Components/Pages/Authentication/CustomImagePreview";
// import { useDataProvider } from 'react-admin';

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  RaFileInput: {
    marginTop: "5px",
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    // marginRight:"auto",
    // marginLeft:"100px",
    // display:"block",
    display: "flex",
    margin: "auto"
  },
  placeholder: {
    color: "red",
    opacity: 1 /* Firefox */
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing(2),
  },
  AddIcon: {
    width: 30,
    marginTop: "25px",
    padding: "0px",
    marginLeft: "50px",
  },
  googleButton: {
    marginTop: "-25px",
    // boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
    textAlign: "center",
    fontFamily: "Larsseit,Helvetica,Arial,Lucida,sans-serif"
  },
  styles: {
    image: { maxHeight: "3rem" }
  }
}));

// const validatePhoneNumber = regex(/^\d{10}$/, "Contact number must be 10 digits");
// const validateStateCity = regex(/^[A-Za-z ]+$/,"Must contain characters only")
const validateDescription = [minLength(2), maxLength(260)];
// const validateStateCharacters = regex(
//   /[_A-z0-9]*((-|\s)*[_A-z0-9])*/,
//   "Should be a valid city name"
// );
const validateName = regex(/^[a-zA-Z ]{2,30}$/);
const validateEmail = email();
const ValidateMobileNo = regex(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "Contact must contain 10 numbers value");
const validatePassword = regex(
  /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{6,20}$/,
  "Password must contain one Small, one Capital letter and should be atleast minimum 6 charachters long"
);
const validateCityAndState = regex(
  /^[a-zA-Z ]{0,20}$/,
  "It must contain characters,should have maximum 20 charachters"
);
const TermsCondition = yup.boolean().required("Must agree term and conditions");
const validateConfirmPassword = (values) => (password) => (
  values.Password === password ? undefined : { message: 'Password does not match' }
)
export const SignUpForm = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest
}) => {
  const classes = useStyles();
  const certificationsData = useQueryWithStore({
    type: 'getList',
    resource: 'Certification',
    payload: {
      filter: {},
      pagination: { page: 1, perPage: 10 },
      sort: { field: "id", order: "ASC" }
    }
  })
console.log("values",values)

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Paper style={{ padding: 5, boxShadow: "none" }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>

            <TextInput
              source="name"
              variant="standard"
              validate={[required(), validateName]}
              fullWidth
              label="Enter Name"
            />
          </Grid>
          <Grid item xs={12}>

            <TextInput
              source="email"
              variant="standard"
              validate={[required(), validateEmail]}
              fullWidth
              label="Enter Email"
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              source="Contact"
              variant="standard"
              validate={[required(), ValidateMobileNo]}
              fullWidth
              label="Enter Contact"
            />
          </Grid>
          <Grid container item xs={12} alignItems="center">
            <Grid>
              {/* <Typography style={{ marginLeft: 3 }}>Upload picture</Typography> */}
            </Grid>
            <Grid>

            </Grid>
            <ImageInput
              variant="contained"
              source="image"
              label=""
              multiple={false}
              accept="image/*"
              placeholder="Select Your Picture"
              color="secondary"
            >
              <CustomImagePreview
                source="image"
                classes={classes.RaFileInput}
                title="title"
                id="contained-button-file"
              />
            </ImageInput>
          </Grid>
          <Grid style={{ padding: '5px' }} container>
            <Grid item xs={4}>
              <SelectInput
                source="country"
                fullWidth
                variant="standard"
                label="Country"
                style={{ minWidth: "92%", }}
                choices={[
                  { id: "India", name: "India" },
                  { id: "Singapore", name: "Singapore" },
                  { id: "Malaysia", name: "Malaysia" },
                  { id: "Australia", name: "Australia" }

                ]}
              />
            </Grid>
            <Grid item xs={4}>

              <TextInput
                source="state"
                style={{ width: "93%", marginLeft: 9 }}
                label="Enter state"
                variant="standard"
                fullWidth
                validate={[validateCityAndState]}
              />
            </Grid>

            <Grid item xs={4}>

              <TextInput
                source="City"
                style={{ width: "92%", marginLeft: 10 }}
                label="Enter City"
                validate={[validateCityAndState]}
                variant="standard"
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <AutocompleteArrayInput
              source="lang"
              label="Language"
              choices={[
                { id: "English", name: "English" },
                { id: "Hindi", name: "Hindi" },
                { id: "Marathi", name: "Marathi" }
              ]}
              variant="standard"
              fullWidth
            />
          </Grid>

          <Grid item xs={10}>

            <AutocompleteArrayInput
              source="Certification"
              label="Certification"
              variant="standard"
              fullWidth
              choices={certificationsData.loaded ? certificationsData.data.map(r=>({id:r.id,name:r.certificateName})) : []}
              optionValue = "name"
            />
          </Grid>
          <Grid item xs={2}>

            <Icon className="fa fa-plus-circle" color="primary" >
              {/* o="/signup/mentor/add-certification" */}
              <Link to="/signup/mentor/add-certification">
                <img className={classes.AddIcon} src={addcircle} alt="add" />
              </Link>
            </Icon>
          </Grid>

          <Grid item xs={12}>
            <TextInput
              source="Description"
              variant="standard"
              fullWidth
              label="Enter Description"
              validate={validateDescription}
            />
          </Grid>

          <Grid item xs={12}>
            <PasswordInput
              source="Password"
              variant="standard"
              validate={[required(), validatePassword]}
              fullWidth
              label="Enter Password"
            />
          </Grid>

          <Grid item xs={12}>
            <PasswordInput
              source="ConfirmPassword"
              variant="standard"
              fullWidth
              validate={[required(), validateConfirmPassword(values)]}
              label="Confirm Password"

            />
          </Grid>

          <Grid item xs={12}>
            <CheckboxGroupInput
              source="TermsCondition"
              validate={[required(), TermsCondition]}
              // label="Agree to Terms & Conditions"
              // alignItems={{}}
              choices={[
                { id: "TermsCondition", name: "Agree to Terms & Conditions" }
              ]}
            />
          </Grid>

          <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
            {/* <Link to="/login"  style={{ textDecoration: 'none',color:"#000000",}} > */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={submitting}
              style={{ width: "100%" }}
            >
              Create Account
            </Button>

            <Snackbar
              // open={open}
              autoHideDuration={3000}
            // onClose={handleClose}
            ></Snackbar>
            {/* </Link> */}
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} style={{ textAlign: "center", paddingTop: "5%" }}>
            <Typography
              variant="subtitle2"
              component="h6"
              style={{ textDecoration: "none", color: "#000000" }}
            >
              Or Create an Account using
            </Typography>
          </Grid>
        </Grid>
        <Grid container style={{ marginTop: "7%" }}>
          <Grid item xs={6} style={{ textAlign: "right", }}>
            <GoogleLogin
              render={renderProps => (
                <Button

                  onClick={renderProps.onClick}
                  disabled={renderProps.disabled}
                  size="large"
                  className={classes.googleButton}
                >
                  <img
                    src={GoogleLogo}
                    alt="google"
                    className={classes.googleIcon}
                  />
                  <p style={{ color: "black" }}>Google</p>
                </Button>
              )}
              clientId="362679134733-lhbmago1bl87idek1lvb1gqmpc7clvhb.apps.googleusercontent.com"
              buttonText="Google"
              onSuccess={payload => signUpGoogle(payload)}
              onFailure={e => {
                signUpGoogleFailure(e);
              }}
            />
          </Grid>

          <Grid item xs={2} style={{ textAlign: "right", }}>
            <img
              src={LinkedinLogo}
              alt={"123Mentor"}
              style={{ width: "23px" }}
            />
          </Grid>
          <Grid item xs={4} style={{ textAlign: "Left", paddingTop: "0%" }}>
            <a
              href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.href}&scope=r_emailaddress%20r_liteprofile&state=linkedinInLogin`}
              style={{
                textDecoration: "none",
                color: "#000000",
                paddingLeft: "5%"
              }}
            >
              LinkedIn
            </a>
          </Grid>
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
              marginTop: "5%",
              paddingBottom: "7%"
            }}
          >
            <Link
              to="/login"
              style={{ textDecoration: "none", color: "#000000" }}
            >
              Already have login and password?{" "}
              <span style={{ fontWeight: "bold" }}>Sign In</span>
            </Link>
          </Grid>
        </Grid>
      </Paper>
    </form>
  );
};
